// extracted by mini-css-extract-plugin
module.exports = {"root":"MergedInvoice_root__2AOUT","header":"MergedInvoice_header__3AoBE"};